var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92245 14.7856H3.18087L11.8132 6.15328L10.5548 4.89486L1.92245 13.5272V14.7856ZM0.15625 16.5518V12.7986L11.8132 1.16376C11.9898 1.00186 12.185 0.876751 12.3987 0.788441C12.6124 0.70013 12.8367 0.655975 13.0716 0.655975C13.3065 0.655975 13.5346 0.70013 13.756 0.788441C13.9774 0.876751 14.1687 1.00922 14.33 1.18584L15.5443 2.42218C15.7209 2.58408 15.8498 2.77542 15.9311 2.99619C16.0123 3.21697 16.0527 3.43775 16.0521 3.65852C16.0521 3.89401 16.0118 4.11862 15.9311 4.33233C15.8504 4.54604 15.7215 4.74091 15.5443 4.91694L3.90943 16.5518H0.15625ZM11.1729 5.53511L10.5548 4.89486L11.8132 6.15328L11.1729 5.53511Z",
    fill: "#8C8A94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.1924f8afc08b79046d1506fb5a7e15a2.svg";
export { ForwardRef as ReactComponent };